export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Pink.096ff7de.jpg";